import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Post } from '../../../models/post.model';
import { Media } from '../../../models/media.model';
import { Translatable } from '../../../models/translatable.model';
import { TimeAgoPipe } from '../../../shared/pipes/time-ago-pipe';

@Component({
  selector: 'app-herovisual',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule, TimeAgoPipe],
  templateUrl: './herovisual.html',
  styleUrl: './herovisual.css',
})
export class Herovisual {
  @Input() postsData: Post[] = [];

  private translate = inject(TranslateService);

  // ── Helpers d'affichage ────────────────────────────────────────────────

  translateField(field: Translatable | null | undefined): string {
    if (!field) return '';
    const lang = this.translate.currentLang as 'fr' | 'en' | 'ar';
    return (field[lang] ?? field.fr ?? '').toString();
  }

  truncate(value: string | null | undefined, max = 90): string {
    if (!value) return '';
    return value.length <= max ? value : value.slice(0, max).trim() + '…';
  }

  getLang(): 'fr' | 'en' | 'ar' {
    const l = this.translate.currentLang;
    return l === 'en' || l === 'ar' ? l : 'fr';
  }

  loadImage(image: Media | null | undefined): string {
    return image?.url || '/assets/images/default_image.png';
  }

  trackById(_: number, post: Post): number {
    return post.id;
  }

  /** Lien vers la fiche article. */
  postLink(post: Post): string[] {
    return ['/articles', post.slug ?? String(post.id)];
  }
}
